import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { theme as defaultTheme } from '@miro-site/design-tokens';
var footer = {
  background: 'primaryIndigo',
  container: {
    width: [null, 1460],
    margin: '0 auto',
    padding: {
      top: [null, null, 40],
      left: [20, 20, 20, 30],
      right: [20, 20, 20, 30],
      bottom: 40
    }
  },
  list: {
    margin: -10,
    padding: {
      right: 40
    }
  },
  item: {
    padding: 10
  },
  innerItem: {
    margin: {
      top: 6
    }
  },
  categoryWrapper: {
    margin: {
      bottom: 24
    }
  },
  categoryTitle: {
    fontSize: 18,
    lineHeight: 24,
    fontWeight: 700
  },
  bottomContainer: {
    margin: {
      top: [null, null, 100]
    },
    padding: {
      top: 40
    }
  },
  innerColumn: {
    margin: {
      right: [null, null, 20, 24]
    }
  },
  copyright: {
    margin: {
      right: [20, 20, 20, 24]
    }
  },
  copyrightLink: {
    margin: {
      right: [20, 20, 20, 24]
    }
  },
  icon: {
    margin: {
      left: 12
    }
  },
  social: {
    margin: {
      top: 30,
      bottom: 26
    }
  },
  socialItem: {
    margin: {
      left: [20, 20, 20, 24]
    }
  },
  links: {
    menu: {
      borderBottom: '1px solid transparent',
      transition: 'border 250ms ease',
      ':hover': {
        borderColor: 'outspoken'
      },
      ':focus': _objectSpread({}, defaultTheme.focus.outlines.withOffset)
    },
    additional: {
      marginTop: 18,
      ':hover .link-text': {
        borderColor: 'outspoken'
      }
    },
    bottom: {
      fontSize: [14, 14, 16],
      lineHeight: 24,
      borderBottom: '1px solid transparent',
      transition: 'border 250ms ease',
      ':hover': {
        borderColor: 'outspoken'
      },
      ':focus': _objectSpread({}, defaultTheme.focus.outlines.withOffset)
    }
  }
};
var accordion = {
  background: 'primaryIndigo',
  gutter: 0,
  itemStyles: {
    borderTop: '1px solid #9B99AF',
    ':first-child': {
      borderTop: 0
    }
  },
  innerList: {
    margin: {
      top: 28
    }
  },
  innerItem: {
    margin: {
      top: 28
    }
  },
  categoryWrapper: {
    padding: [20, 24]
  },
  category: {
    fontSize: 18,
    fontWeight: 700,
    lineHeight: 20,
    color: 'white'
  },
  description: {
    fontSize: 14,
    lineHeight: 20,
    color: 'white',
    opacity: '0.8',
    margin: {
      top: 6
    }
  },
  subcategoryWrapper: {
    padding: {
      left: [20, 34],
      top: 34,
      bottom: 32
    },
    margin: {
      top: -32
    }
  },
  subcategory: {
    fontSize: 18,
    fontWeight: 700,
    lineHeight: 24,
    color: 'white',
    margin: {
      top: 30
    }
  },
  additionalLink: {
    margin: {
      top: 30
    }
  },
  innerLink: {
    fontSize: 18,
    lineHeight: 24
  }
};

var theme = _objectSpread(_objectSpread({}, defaultTheme), {}, {
  viewportsArray: ['v2Mobile', 'v2Tablet', 'v2Desktop', 'v2LargeDesktop', 'v2XLargeDesktop'],
  footer: footer,
  accordion: accordion
});

export default theme;